exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".repeater-form{padding:2rem 0 14rem;margin-left:-1.5rem}.repeater-form__row{position:relative}.repeater-form__row:hover .remove{opacity:1;visibility:visible}.repeater-form__row .input-wrap{width:auto}.repeater-form__cell{display:inline-block;padding-left:1.5rem}.repeater-form__cell .remove{color:#fff;background-color:#999;-webkit-appearance:none;border:0;line-height:1.5;font-size:10px;border-radius:10px;position:absolute;top:3.5rem;left:2.5rem;opacity:0;visibility:hidden;transition:background-color .1s ease,opacity .1s ease,visibility .1s ease}.repeater-form__cell .remove:hover{background-color:#f26673}.cell-100{width:100%}.cell-50{width:50%}.cell-33{width:33.3333%}.cell-25{width:25%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-05ff41a8!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/RepeaterForm.vue
// module id = 260
// module chunks = 0